import lng from '@lightningjs/core';
import { Colors } from '@lightningjs/sdk';

export default class EpisodesInfo extends lng.Component {
  static _template() {
    return {
      ...super._template(),
      Info: {
        flex: { direction: 'column', justifyContent: 'center' },
        Title: {
          y: 70,
          text: {
            fontSize: 60,
            lineHeight: 68,
            maxLines: 3,
            wordWrapWidth: 600,
            textColor: Colors('#FAFAFA').get(),
            fontFace: 'OpenSans-SemiBold',
          },
        },
        Informations: {
          y: 55,
          DurationAndIcon: {
            Svg: {
              y: 3,
              w: 25,
              h: 25,
              zIndex: 0,
            },
            text: {
              fontSize: 29,
              maxLines: 1,
              wordWrapWidth: 600,
            },
          },
          Rating: {
            text: {
              fontSize: 26,
              maxLines: 1,
              wordWrapWidth: 600,
            },
          },
          Votes: {
            y: 7,
            text: {
              fontSize: 18,
              maxLines: 1,
              wordWrapWidth: 600,
            },
          },
          ContentRating: {
            x: 375,
            text: {
              fontSize: 26,
              maxLines: 1,
              wordWrapWidth: 600,
            },
          },
        },
        Category: {
          y: 100,
          text: {
            fontSize: 24,
            maxLines: 1,
            wordWrapWidth: 600,
            fontFace: 'OpenSans-Regular',
          },
        },
        Description: {
          y: 120,
          h: 200,
          text: {
            fontSize: 30,
            lineHeight: 34,
            wordWrapWidth: 600,
            maxLines: 5,
            fontFace: 'OpenSans-Regular',
            textColor: Colors('#fafafa').get(),
          },
        },
        Season: {
          y: 140,
          x: 0,
          text: {
            fontSize: 30,
            lineHeight: 34,
            lineHeight: 37,
            wordWrapWidth: 600,
            maxLines: 5,
          },
        },
      },
      Cover: {
        x: 600,
        y: 0,
        w: 1200,
        h: 690,
        alpha: 0.9,
        texture: {
          type: lng.textures.ImageTexture,
        },
        shader: { type: lng.shaders.FadeOut, fade: [0, 0, 90, 90] },
      },
    };
  }
}
